import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment, a as Host } from './index.js';
import { h as handleDismiss } from './p-CY_xCDya.js';
import { g as getAlertOrBannerIcon } from './p-4eps5r2r.js';
import { d as defineCustomElement$5 } from './p-B3XAsdJo.js';
import { d as defineCustomElement$4 } from './p-Dr61d_nc.js';
import { d as defineCustomElement$3 } from './p-_P4kPR3l.js';
import { d as defineCustomElement$2 } from './p-CdhcNtiX.js';

const bannerCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.75rem 1rem;position:relative;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}.content{align-items:center;display:flex;flex:1;gap:1rem}.content wui-icon{align-self:flex-start;margin:.125rem 0}.content h2,.content h3,.content h4,.content h5{align-items:center;display:flex;margin:0;min-height:2rem;padding:0}.content h2{font-size:1.25rem;line-height:1.75rem}.content h2,.content h3{font-family:Open Sans;font-weight:400;letter-spacing:-.0008em}.content h3{font-size:1.125rem;line-height:1.5rem}.content h4{font-family:Open Sans;font-size:1rem;font-weight:600;letter-spacing:-.0008em;line-height:1.5rem}.content h5{font-family:Open Sans;font-size:.75rem;font-weight:700;letter-spacing:.03em;line-height:1rem;text-transform:uppercase}.content p{font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;margin:0;padding:0 0 .375rem}.content .text-group{max-width:var(--jw-container-xl)}:host([type=info]){background-color:var(--jw-theme-info-bold-message-bg-color);color:var(--jw-theme-info-bold-message-color)}:host([type=info]) ::slotted(a),:host([type=info]) ::slotted(a:hover){--color:var(--jw-theme-info-bold-message-color)!important;color:var(--color)!important}:host([type=warning]){background-color:var(--jw-theme-warning-bold-message-bg-color);color:var(--jw-theme-warning-bold-message-color)}:host([type=warning]) ::slotted(a),:host([type=warning]) ::slotted(a:hover){--color:var(--jw-theme-warning-bold-message-color)!important;color:var(--color)!important}:host([type=error]){background-color:var(--jw-theme-error-bold-message-bg-color);color:var(--jw-theme-error-bold-message-color)}:host([type=error]) ::slotted(a),:host([type=error]) ::slotted(a:hover){--color:var(--jw-theme-error-bold-message-color)!important;color:var(--color)!important}:host([type=success]){background-color:var(--jw-theme-success-bold-message-bg-color);color:var(--jw-theme-success-bold-message-color)}:host([type=success]) ::slotted(a),:host([type=success]) ::slotted(a:hover){--color:var(--jw-theme-success-bold-message-color)!important;color:var(--color)!important}:host([type=promo]){background-color:var(--jw-theme-promo-bg-color);border-bottom:2px solid var(--jw-theme-promo-border-color);color:var(--jw-theme-promo-text-color)}:host([type=promo]) ::slotted(a),:host([type=promo]) ::slotted(a:hover){--color:var(--jw-theme-promo-text-color)!important;color:var(--color)!important}:host([type=promo]) h5{align-self:flex-start;color:var(--jw-theme-promo-label-color);line-height:1.25rem;white-space:nowrap}:host([data-size=md]) .content{justify-content:center}:host([data-size=lg]){justify-content:flex-start}:host([data-size=lg]) .content{justify-content:flex-start}";

const WuiBanner$1 = /*@__PURE__*/ proxyCustomElement(class WuiBanner extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.dismiss = createEvent(this, "dismiss", 3);
        //////// DISMISSIBLE START ////////
        this.dismissible = true;
        this.handleDismiss = () => handleDismiss(this);
        //////// DISMISSIBLE END ////////
        /**
         * UI type
         */
        this.type = 'info';
        /**
         * Label prepended to custom content (for promo only)
         */
        this.promoLabel = 'New Feature 🎉';
    }
    render() {
        const icon = getAlertOrBannerIcon(this.type);
        return (h(Host, { key: 'ac26a38f1b509c6a7687969d2817bd06eef9dca7', "data-size": this.heading ? 'lg' : 'md' }, h("div", { key: 'c51534996ad3d409ed076216a29a6473b93ac754', class: "content" }, this.heading ? (h("div", { class: "text-group" }, this.heading && h("h4", null, this.heading), h("p", null, h("slot", null)))) : (h(Fragment, null, icon && h("wui-icon", { part: "banner-icon", size: "md", name: icon }), this.type === 'promo' && h("h5", null, this.promoLabel), h("div", null, h("slot", null))))), h("div", { key: '3ac6a35b34cfb8a1801eec441c4b474623e3d5c0', class: "actions" }, this.dismissible && (h("wui-close-button", { key: '383d67b29856321d7c2fe089023e03b35e9ea178', type: "bold", size: "sm", onClick: () => {
                this.handleDismiss();
            } })))));
    }
    get elm() { return this; }
    static get style() { return bannerCss; }
}, [257, "wui-banner", {
        "dismissible": [4],
        "type": [513],
        "heading": [1],
        "promoLabel": [1, "promo-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-banner", "wui-close-button", "wui-icon", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-banner":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiBanner$1);
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiBanner = WuiBanner$1;
const defineCustomElement = defineCustomElement$1;

export { WuiBanner, defineCustomElement };
